import styled from 'styled-components'

import { colors, spaces } from 'global-parameters'

export default styled.div`
    width: 100%;
    height: 100%;
    background-color: ${colors.white};
    border-radius: 8px;
    padding: ${spaces.m};
    overflow-y: auto;
  `

export const Title = styled.div`
  color: ${colors.black};
  font-weight: bold;
  font-size: 21px;
`
